import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Icon,
} from "@mui/material";
import PropTypes from "prop-types";
import "./BMXServiceRadioButton.scss";

const BMXServiceRadioButton = ({
  input,
  meta,
  options,
  label,
  disabled,
  row,
  labelFontSize = "0.75rem",
  mainLabelFontSize = "0.85rem",
}) => {
  return (
    <FormControl
      component="fieldset"
      className="BMXServiceRadioButton"
      disabled={disabled}
    >
      {label && (
        <FormLabel
          sx={{
            color: "inherit",
            "&.Mui-focused": {
              color: "inherit",
            },
            fontSize: mainLabelFontSize,
          }}
          component="legend"
        >
          {label}
        </FormLabel>
      )}

      <RadioGroup
        row={row}
        name={input.name}
        value={input.value || ""}
        onChange={(e) => input.onChange(e.target.value)}
        className="ServiceRadioButton"
      >
        {options.map(({ value, icon, label, color }) => (
          <FormControlLabel
            key={value}
            value={value}
            control={<Radio />}
            label={
              <div className="d-flex flex-column align-items-center">
                {icon && (
                  <Icon
                    fontSize="small"
                    style={{ color: color ? color : "#757575" }}
                    className="text"
                  >
                    {icon}
                  </Icon>
                )}
                <span style={{ fontSize: labelFontSize }}>{label}</span>
              </div>
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default BMXServiceRadioButton;

{
  /* <Field
  name="selectFolder"
  component={BMXServiceRadioButton}
  options={[
    { value: "empty", icon: "do_disturb", label: "Brak" },
    { value: "client", icon: "airport_shuttle", label: "u Klienta" },
    { value: "local", icon: "apartment", label: "Lokalnie" },
    { value: "remotely", icon: "headset_mic", label: "Zdalnie" },
  ]}
  defaultValue="brak"
  label={t("global:settings.selectFolder")}
/> */
}
